import _ from 'lodash';
import api from '../api';
import { LOGOUT_SUCCESS } from '../actions/logout'; 

// These are your top-level constants causing the previous crashes
const UNLOCK_REQUEST = api.events.profilesUnlock.actionFetch;

const defaultState = { 
  all: [],
  hasProfile: false,
  hasToken: false,
  isFetching: false,
  oldToken: null,
  profile: null,
  token: null
};

export default function auth(state = defaultState, action) {
  // Move this to the top of the switch to ensure it has priority
  if (action.type === LOGOUT_SUCCESS || action.type === 'LOGOUT_SUCCESS') {
    return defaultState;
  }

  switch (action.type) {
    case api.events.accountsList.actionSuccess:
      return { ...state, all: action.data };
      
    case api.events.accountsDischarge.actionSuccess:
    case api.events.accountsPatch.actionSuccess:
    case api.events.accountsGet.actionSuccess:
      return {
        ...state,
        all: _.unionBy([action.data], state.all, account => account.id)
      };

    default:
      return state;
  }
}
